export const validateHbtDataTableCellValue = (value: string) => {
  const lowerCaseValue = value && value.trim().toLowerCase();
  return !lowerCaseValue || ['', 'unknown', '0', '-'].indexOf(lowerCaseValue) !== -1;
};
